import React, { PureComponent } from "react";
import { Container } from "react-bootstrap";

class AuctionProduct extends PureComponent {
  render() {
    return (
      <>
        <Container className="my-5">Auction Product Page</Container>
      </>
    );
  }
}

export default AuctionProduct;
